import { RouterModule, Routes } from '@angular/router';

import { AppLayoutComponent } from './app-layout/app-layout.component';
import { BalanceOutstandingComponent } from './balance-outstanding/balance-outstanding.component';
import { BalanceOutstandingResolver } from './services/balance-outstanding.resolver';
import { BillAssetComponent } from './bill-asset/bill-asset.component';
import { CheckAccessService } from './services/checkAccess.service';
import { DeactivateGuardService } from './services/deactivateGuardService.service';
import { ErrorComponent } from './error/error.component';
import { ExtractAccountComponent } from './extract-account/extract-account.component';
import { HomeComponent } from './home/home.component';
import { HomeResolver } from './services/home.resolver';
import { InfosContactComponent } from './infos-contact/infos-contact.component';
import { InitializerGuard } from './services/initializer.guard';
import { PaymentCardsComponent } from './payment-cards/payment-cards.component';
import { PaymentIframeComponent } from './payment-iframe/payment-iframe.component';
import { PaymentIframeGuard } from './services/payment-iframe.guard';
import { PaymentMeansComponent } from './payment-means/payment-means.component';
import { PaymentMeansResolver } from './services/payment-means.resolver';
import { PaymentStatusReturnService } from './services/payment-status-return.service';
import { PurchaseOrdersSignComponent } from './purchase-orders-sign/purchase-orders-sign.component';
import { RedirectGuard } from './services/redirect.guard';
import { Right } from './models/Rights.enum';
import { SelectPayGuard } from './services/select-pay.guard';
import { SelectPayResolver } from './services/select-pay.resolver';
import { SepaMandateFormComponent } from './sepa-mandate-form/sepa-mandate-form.component';
import { StaticReferences } from './services/staticReference.model';
import { UserService } from './services/user.service';

const appRoutes: Routes = [
  {
    path: 'purchase-orders-sign/:doc-id/:hash-secu',
    component: PurchaseOrdersSignComponent
  },
  {
    path: 'sepa-sign/:tiers-id/:supplier-id/:hash-secu',
    component: SepaMandateFormComponent,
    canDeactivate: [DeactivateGuardService]
  },
  {
    path: 'payment-status/:status',
    component: HomeComponent,
    canActivate: [PaymentStatusReturnService]
  },
  { path: 'error', component: ErrorComponent },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [InitializerGuard],
    children: [
      {
        path: 'home', component: HomeComponent,
        canActivate: [UserService],
        resolve: { lateBillsNb: HomeResolver }
      },
      {
        path: 'bill-asset', component: BillAssetComponent,
        canActivate: [UserService, CheckAccessService],
        data: { accessRight: Right.Payment }
      },
      {
        path: 'extract-account', component: ExtractAccountComponent,
        canActivate: [UserService, CheckAccessService],
        data: { accessRight: Right.AccountExtract }
      },
      {
        path: 'balance-outstanding', component: BalanceOutstandingComponent,
        canActivate: [UserService, CheckAccessService],
        data: { accessRight: [Right.Payment, Right.Cart] },
        resolve: { balanceOutstandingInfos: BalanceOutstandingResolver }
      },
      {
        path: 'select-pay/:supplierId', component: PaymentCardsComponent,
        canDeactivate: [DeactivateGuardService],
        canActivate: [UserService, SelectPayGuard, CheckAccessService],
        data: { accessRight: Right.Payment },
        resolve: { selectPayInfos: SelectPayResolver }
      },
      {
        path: 'payment-means', component: PaymentMeansComponent,
        canActivate: [UserService, CheckAccessService],
        data: { accessRight: Right.Payment },
        resolve: { paymentMeansInfos: PaymentMeansResolver }
      },
      {
        path: 'payment-iframe', component: PaymentIframeComponent,
        canActivate: [UserService, PaymentIframeGuard, CheckAccessService],
        data: { accessRight: Right.Payment },
        canDeactivate: [DeactivateGuardService]
      },
      {
        path: 'infos-contact', component: RedirectGuard,
        canActivate: [UserService, RedirectGuard],
        data: {
          externalUrl: new StaticReferences().UrlSlPlusSupport,
          openInNewTab: true
        }
      },
      {
        path: 'sepa-mandate-sign/:supplier-id', component: SepaMandateFormComponent,
        canDeactivate: [DeactivateGuardService],
        canActivate: [UserService, CheckAccessService],
        data: { accessRight: Right.Payment }
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: '**', redirectTo: 'home' }
    ]
  }
];

export const appRoutingProviders: any[] = [];

export const routing = RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' });
